module.exports = __webpack_public_path__ + "img/clear.572ef485.svg";